import { render, staticRenderFns } from "./locationCreateModal.vue?vue&type=template&id=2df2b74c&"
import script from "./locationCreateModal.vue?vue&type=script&lang=ts&"
export * from "./locationCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports